<template>
  <b-row>
    <b-col lg="3">

      <div v-if="screenWidth">
        <m-features-1 @features="setProductFeature"/>
        <m-categories-panel-302 @category="setProductCategory"/>
        <m-brands-301 @brand="setProductBrand"/>
      </div>

      <b-button v-if="!screenWidth" class="my-5" v-b-toggle.filter-sidebar>
        <b-icon-gear-fill/>
        فیلترها
      </b-button>

      <b-sidebar id="filter-sidebar" shadow>
        <m-features-1 @features="setProductFeature"/>
        <m-categories-panel-302 @category="setProductCategory"/>
        <m-brands-301 @brand="setProductBrand"/>
      </b-sidebar>

    </b-col>
    <b-col lg="9">

      <b-row class="bg-white shadow product-order py-3" align-v="center">
        <span class="mx-3 text-muted ">مرتب سازی بر اساس:</span>

        <label for="asc" class="mx-2 btn "
               :class="{'text-white btn-primary':sort==='asc','text-dark btn-outline-primary':sort!=='asc'}">
          ارزان ترین
        </label>
        <input id="asc" name="price_order" value="asc" v-model="sort" type="radio" class="d-none">

        <label for="desc" class="mx-2 btn"
               :class="{'text-white btn-primary':sort==='desc','text-dark btn-outline-primary':sort!=='desc'}">
          گران ترین
        </label>
        <input id="desc" name="price_order" value="desc" v-model="sort" type="radio" class="d-none">


      </b-row>

      <m-products-wrapper :product-brands="productBrand" :sort="sort" :product-features="productFeature"
                          :product-categories="productCategory">
        <b-row slot-scope="{products,pagination,changePageFunction}">
          <div class="col-lg-4 mt-3" v-for="product in products" :key="product.id">
            <m-c301 class="product-card" :product="product"/>
          </div>

          <b-col lg="12" v-if="paginate">
            <m-pagination-400 class="mx-auto my-2" :meta="pagination" :on-change-page="changePageFunction"/>
          </b-col>

        </b-row>

      </m-products-wrapper>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "Products304",
  props: {
    paginate: {
      default: false
    }
  },
  data() {
    return {
      productCategory: null,
      productFeature: null,
      sort: '',
      productBrand: null,
    }
  },
  methods: {
    setProductCategory(category) {
      this.productCategory = [category]
    },
    setProductFeature(feature) {
      this.productFeature = feature.length > 0 ? feature : null
    },
    setProductBrand(brand) {
      this.productBrand = brand.length > 0 ? brand : null
    },
  },
  computed: {
    screenWidth() {
      return window.outerWidth >= 1000
    }
  }
}
</script>

<style scoped>
.product-order {
  border-radius: 10px;
}
</style>